module.exports = __webpack_public_path__ + "static/media/totalRequestAmountIcon.03d3e2e4.svg";